export const config = {
    appname: "NescafeStreetCafe",
    client_id: "147393556829911", // App ID //147393556829911
    facebook_app_id: "147393556829911", // Facebook App ID (Should be the same)
    debug: false, //enable console.log,
    sponsor_id: "198409", // waiting
    prefix: "apinsc2",

    // ------------- Production Settings ----------------
    api: "apinsc2",
    agency_id: "45575",
    bzbsUrl: "https://apinsc2.buzzebees.com",
    bzbsUrlWallet: "https://apinsc2wallet.buzzebees.com",
    bzbsModuleUrl: "https://nestlemodule.buzzebees.com",
    apiShoppingCartUrl: "https://shoppingcartmodule28.buzzebees.com",
    webShoppingCartUrl: "https://shoppingcartservice28.buzzebees.com",
    apiShippingUrl: "https://shippingmodule28.buzzebees.com",
    bzbsBlobUrl: "https://buzzebees.blob.core.windows.net",
    miscUrl: "https://misc.buzzebees.com",
    bzbsGaId: "",
    bzbsAnalyticUrl: "https://analytics-api-01.buzzebees.com/",
    bzbsAnalyticId: "340",
    liffId: "1657051077-vG4Vg3oM", //  waiting
    // ------------------ End Settings ---------------------
    fbLogOnUrl: "https://www.facebook.com/dialog/oauth?",
    fbPermissions: ["email"],

    firebase: {
        apiKey: "",
        authDomain: "",
        databaseURL: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: "",
    },
};
